angular
    .module('app')
    .component('campaigns', {
        templateUrl: '/templates/pages/campaigns/campaigns.html',
        controller: 'CampaignsController',
        controllerAs: 'vm',
    });